__webpack_require__.p = "/wp-content/themes/app-theme/assets/c/";